import { render, staticRenderFns } from "./OpenImageGroupButton.vue?vue&type=template&id=226f03b8&scoped=true"
import script from "./OpenImageGroupButton.vue?vue&type=script&lang=js"
export * from "./OpenImageGroupButton.vue?vue&type=script&lang=js"
import style0 from "./OpenImageGroupButton.vue?vue&type=style&index=0&id=226f03b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f03b8",
  null
  
)

export default component.exports